export const TRANSLATIONS_EN_GB = {
  PANEL_PLACEMENT_INFO:
    'Panel placement may not be as accurate as we would like depending on quality of rooftop data and image. Our technical team will review this before survey.',
};
